import React from "react";
import heroImage from "../../assets/image/crm-ai-abstract.png";

function StaffDashboard() {
  return (
    <div className="dashboard">
      <div className="dash-hero">
        <img src={heroImage} alt="Staff workspace" />
        <div className="dash-hero-overlay">
          <span className="dash-hero-chip">Staff workspace</span>
          <h2>Welcome to your dashboard</h2>
          <p>
            Use the sidebar to open leads, reminders, meetings and chat. Live
            counts appear here when your staff dashboard APIs are connected.
          </p>
        </div>
      </div>
    </div>
  );
}

export default StaffDashboard;
